<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
  </div>
</template>

<script>
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiHospitalBoxOutline } from "@mdi/js"

export default {
  name: "IllnessIcon",
  components: {
    SvgIcon
  },
  data() {
    return {
      path: mdiHospitalBoxOutline,
    }
  }
}
</script>
